import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { DIALOG_DATA } from '../../../../global.variable';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RosterService } from '../../../pages/pages/roster/roster.service';

@Component({
  selector: 'gtapp-request-leave',
  standalone: false,
  templateUrl: './request-leave.component.html',
  styleUrl: './request-leave.component.scss',
})
export class RequestLeaveComponent implements OnInit, OnDestroy {
  leaveForm: UntypedFormGroup = new UntypedFormGroup({
    reason: new UntypedFormControl('', Validators.required),
    leave_session: new UntypedFormControl(0),
    leave_dates: new UntypedFormControl([], Validators.required),
  });
  leaveSessionDict: any = {
    0: 'Full Day',
    1: 'Forenoon',
    2: 'Afternoon',
  };

  constructor(
    @Optional() protected dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public dialogData: any,
    private rosterService: RosterService,
  ) {}

  ngOnDestroy(): void {}
  ngOnInit(): void {}

  onCloseDialog(val = false) {
    this.dialogRef.close(val);
  }
  clearAndFocusInputField(elementId: string) {
    this.leaveForm.controls['reason'].setValue('');
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  onSelectDate(event: any) {
    this.leaveForm.controls['leave_dates'].setValue(event);
  }
  submitLeaves() {
    this.rosterService
      .applyLeave({}, this.leaveForm.value)
      .subscribe((response: any) => {
        this.onCloseDialog();
      });
  }
}
